// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';
import DateRangePicker from '../../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class FormView extends JQueryView {
  newUrl: string;

  constructor(newUrl: string) {
    super('#new_company_share_stock');
    const control = $('.form-group-float .form-control');
    if (control.val() && control.val().length !== 0) {
      control.addClass('form-control-active');
    } else {
      control.removeClass('form-control-active');
    }
    this.newUrl = newUrl;
    this.render();
  }

  @on({ event: 'keydown', selector: '.date-field' })
  preventTypingDate(event: any) {
    const key = event.keyCode;
    if (key === 8) {
      $(event.currentTarget).val('');
    }
    return false;
  }

  @on({ event: 'click', selector: '.cancel_button' })
  onCancelButton() {
    const form = $('.simple_form');
    form.attr('method', 'get');
    form.attr('data-remote', 'true');
    form.attr('action', this.newUrl);
    $('#cancel_button').click();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'Y/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'Y/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
